export const SITES_MAP_LAYER_ID = "SitesMapLayer";
